module.exports = __webpack_public_path__ + "img/paint-07.27b099ed.png";